import { useState, useMemo, ChangeEvent } from 'react';
import { Select, Tooltip } from 'common/components';
import { useGetAccessManager } from 'services/hooks/queries';
import { getScopedTenantId, setScopedTenantId, TENANT_SCOPE_REQUIRED_MESSAGE } from 'services/api/config/scopedTenant';
import { queryClient } from 'services/providers/QueryProvider';

export const TenantList = () => {
    const storedTenantId = getScopedTenantId();
    const [tenant, setTenant] = useState<string>(storedTenantId || '');
    const { accessManagerData } = useGetAccessManager();

    const tenants = useMemo(() => {
        return (
            accessManagerData?.tenants?.map((tenant) => ({
                label: tenant.name,
                value: tenant.id,
            })) || []
        );
    }, [accessManagerData]);

    const handleTenantChange = (event: ChangeEvent<HTMLSelectElement>) => {
        const next = event.target.value;
        setTenant(next);
        setScopedTenantId(next || null);
        void queryClient.invalidateQueries();
    };

    const isTenantSelected = Boolean(tenant);

    return (
        <Tooltip
            content={TENANT_SCOPE_REQUIRED_MESSAGE}
            isVisible={!isTenantSelected}
            position='bottom'
            disabled={isTenantSelected}
            maxWidth={280}
        >
            <div style={{ minWidth: '200px' }}>
                <Select
                    options={tenants}
                    value={tenant}
                    onChange={handleTenantChange}
                    placeholder='Tenant scope'
                    isSearchable
                    size='sm'
                    aria-label='Super-admin tenant scope for API requests'
                />
            </div>
        </Tooltip>
    );
};
